// What /wine/:id, /winery/:id and /appellation/:id show for an id druif does not have: a
// real not-found state with a way out, never another screen's content. A wine the user
// typed in by hand has no catalogue row at all, which is a different message.
import { useT } from "../lib/i18n";
import { navigate } from "../lib/router";
import { Button, EmptyState, Icon, Screen, ScreenHeader } from "../ui";

export function EntityNotFound({ manual = false }: { manual?: boolean }): React.JSX.Element {
  const { t } = useT();
  return (
    <Screen data-testid="entity-notfound">
      <ScreenHeader backFallback="/" />
      <EmptyState
        icon={manual ? "pencil" : "search"}
        title={t(manual ? "entity.manual.title" : "entity.notfound.title")}
        body={t(manual ? "entity.manual.body" : "entity.notfound.body")}
        action={
          <Button
            tone="secondary"
            icon={<Icon name="search" size={18} />}
            onPress={() => {
              navigate("/search");
            }}
          >
            {t("entity.notfound.action")}
          </Button>
        }
      />
    </Screen>
  );
}
